import { render, staticRenderFns } from "./ConfigurationFiltersView.vue?vue&type=template&id=b0d84758"
import script from "./ConfigurationFiltersView.vue?vue&type=script&lang=js"
export * from "./ConfigurationFiltersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports